if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        })
      }

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
        if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
      }

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

(function () {
  const variantMediaSync = {
    init() {
      document.addEventListener('change', (event) => {
        const picker = event.target && event.target.closest && event.target.closest('variant-selects, secondary-variant-select, secondary-variant-select-separate');
        if (!picker) return;
        window.requestAnimationFrame(() => this.syncPicker(picker));
      });

      document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('variant-selects, secondary-variant-select, secondary-variant-select-separate').forEach((picker) => {
          this.syncPicker(picker);
        });
      });

      window.addEventListener('pageshow', () => {
        document.querySelectorAll('variant-selects, secondary-variant-select, secondary-variant-select-separate').forEach((picker) => {
          this.syncPicker(picker);
        });
      });
    },

    syncPicker(picker) {
      const variant = this.currentVariant(picker);
      const mediaId = variant && variant.featured_media && variant.featured_media.id;
      const sectionId = picker.dataset.section;
      if (!mediaId || !sectionId) return;
      this.activateMedia(sectionId, `${sectionId}-${mediaId}`);
    },

    currentVariant(picker) {
      const variants = this.variants(picker);
      if (!variants.length) return null;

      const selectedOptions = this.selectedOptions(picker);
      if (selectedOptions.length) {
        const match = variants.find((variant) => {
          if (!Array.isArray(variant.options) || variant.options.length !== selectedOptions.length) return false;
          return variant.options.every((option, index) => String(option) === selectedOptions[index]);
        });
        if (match) return match;
      }

      const idInput = document.querySelector(`#product-form-${picker.dataset.section} input[name="id"], #ProductForm-${picker.dataset.section} input[name="id"]`);
      const selectedId = idInput && idInput.value;
      if (selectedId) return variants.find((variant) => String(variant.id) === String(selectedId)) || null;

      const urlVariant = new URLSearchParams(window.location.search).get('variant');
      if (urlVariant) return variants.find((variant) => String(variant.id) === String(urlVariant)) || null;

      return null;
    },

    variants(picker) {
      if (picker._bowtieVariantMediaVariants) return picker._bowtieVariantMediaVariants;
      const script = picker.querySelector('script[type="application/json"]');
      if (!script) return [];
      try {
        const variants = JSON.parse(script.textContent || '[]');
        picker._bowtieVariantMediaVariants = Array.isArray(variants) ? variants : [];
      } catch (error) {
        picker._bowtieVariantMediaVariants = [];
      }
      return picker._bowtieVariantMediaVariants;
    },

    selectedOptions(picker) {
      return Array.from(picker.querySelectorAll('.product-form__input'))
        .map((group) => {
          const select = group.querySelector('select');
          if (select) return select.value;
          const checked = group.querySelector('input[type="radio"]:checked');
          if (checked) return checked.value;
          return null;
        })
        .filter((value) => value !== null)
        .map((value) => String(value));
    },

    activateMedia(sectionId, mediaId) {
      const gallery = document.getElementById(`MediaGallery-${sectionId}`);
      if (!gallery) return;

      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
        return;
      }

      const viewer = gallery.querySelector(`#GalleryViewer-${CSS.escape(sectionId)}, [id^="GalleryViewer"]`);
      const activeMedia = viewer && viewer.querySelector(`[data-media-id="${CSS.escape(mediaId)}"]`);
      if (!activeMedia) return;

      viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.toggle('is-active', element === activeMedia);
      });

      const list = activeMedia.parentElement;
      if (list && typeof list.scrollTo === 'function') {
        list.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });
      }

      const thumbnails = gallery.querySelector(`#GalleryThumbnails-${CSS.escape(sectionId)}, [id^="GalleryThumbnails"]`);
      if (!thumbnails) return;

      thumbnails.querySelectorAll('button').forEach((button) => button.removeAttribute('aria-current'));
      const activeThumbnail = thumbnails.querySelector(`[data-target="${CSS.escape(mediaId)}"]`);
      const activeButton = activeThumbnail && activeThumbnail.querySelector('button');
      if (activeButton) activeButton.setAttribute('aria-current', 'true');

      const thumbnailList = activeThumbnail && activeThumbnail.parentElement;
      if (thumbnailList && typeof thumbnailList.scrollTo === 'function') {
        thumbnailList.scrollTo({ left: activeThumbnail.offsetLeft, behavior: 'smooth' });
      }
    },
  };

  variantMediaSync.init();
})();
